import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import Input from '../Input.js';
import TimespanInput from '../TimespanInput.js';
const TimePickerInput = React.forwardRef((props, ref) => React.createElement(Input, { ...props, inputRef: ref }));
const TimingInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const { disabled, timing } = props;
    return (React.createElement("div", null,
        React.createElement("h4", null, lang.workflows.timespan),
        React.createElement(TimespanInput, { disabled: disabled, 
            // Workflow timings can be negative — e.g. anchored a week before a
            // voucher's due date — so this input keeps no floor.
            min: null, value: timing.details.timespan, onChange: (timespan) => {
                props.onChange({
                    ...timing,
                    details: {
                        ...timing.details,
                        timespan,
                    },
                });
            } }),
        React.createElement(TimePickerWrapper, null, React.createElement(DatePicker, { customInput: React.createElement(TimePickerInput, { disabled: disabled }), placeholderText: lang.workflows.timeOfDay, disabled: disabled, selected: timing.details.time
                ? moment().set(timing.details.time).toDate()
                : null, onChange: (date) => {
                props.onChange({
                    ...timing,
                    details: {
                        ...timing.details,
                        time: date
                            ? {
                                hour: date.getHours(),
                                minute: date.getMinutes(),
                            }
                            : null,
                    },
                });
            }, showTimeSelect: true, showTimeSelectOnly: true, timeIntervals: 15, timeCaption: "Time", dateFormat: "HH:mm", timeFormat: "HH:mm" }))));
};
export default TimingInput;
const TimePickerWrapper = styled.div `
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    display: block;
  }
`;
//# sourceMappingURL=TimingInput.js.map